import { createSelector } from 'reselect';
import { sortByName, createOptionsSelector } from '@mews-commander/utils';
import { ProductCategory, getProductCategories } from '../ducks/productCategories';
import { localizedEntities } from '../ducks/utils';

export const getProductCategoriesOptions = createOptionsSelector(
    localizedEntities(getProductCategories, 'names', 'name'),
    { sortFunction: sortByName }
);

function sortNestedProductCategories(categories: ProductCategory[]): string[] {
    const map = new Map<string, ProductCategory>();

    for (const category of categories) {
        map.set(category.id, category);
    }

    function getSortedIds(id: string): string[] {
        const category = map.get(id);
        if (!category) return [];
        const nestedIds = categories
            .filter((c) => c.parentCategoryId === id)
            .sort((a, b) => a.ordering - b.ordering)
            .flatMap((c) => getSortedIds(c.id));
        return [id, ...nestedIds];
    }

    const topLevelCategories = categories
        .filter((c) => c.parentCategoryId == null)
        .sort((a, b) => a.ordering - b.ordering);

    const sortedIds = topLevelCategories.flatMap((c) => getSortedIds(c.id));

    return sortedIds;
}

export const getSortedProductCategoryIdsByOrdering = createSelector(
    localizedEntities(getProductCategories, 'names', 'name'),
    sortNestedProductCategories
);
